const sharedFeeTransactionFields = `
    _id
    meta {
        isDeleted
    }
    createdAt
    dateReceived
    dateRequested
    lastInvoicedAt
    feeType
    product {
        ... on DafProduct {
            _id
            name
            fundingAccount {
                ... on AccountAsset {
                    _id
                    institution
                    accountLogin
                }
            }
        }
        ... on ClatProduct {
            _id
            name
            fundingAccount {
                ... on AccountAsset {
                    _id
                    institution
                    accountLogin
                }
            }
        }
        ... on CommunityFundProduct {
            _id
            name
            fundingAccount {
                ... on AccountAsset {
                    _id
                    institution
                    accountLogin
                }
            }
        }
    }
    quarter
    receivedAmount
    requestedAmount
    status
    queue
    holdNote
    quickbooksInvoiceNumber
    readyToCollect
    daysOutstanding
    waivedAmount
    year
    meta {
        notes
    }
    denormalized {
        payerName
        productName
        assetName
    }
    users {
        _id
        associationType
        user {
            ... on InternalUser {
                _id
                firstName
                lastName
            }
            ... on DonorUser {
                _id
                firstName
                lastName
                advisor {
                    _id
                    firstName
                    lastName
                }
            }
            ... on FirmUser {
                _id
                firstName
                lastName
            }
            ... on EntityUser {
                _id
                firstName
                lastName
            }
        }
    }
`;

const workflowProductTotals = `
    product {
        ... on DafProduct {
            waiveFeeReserve
            totals {
                availableToGrant
                estimatedFeeReserve
                uncalledCapital
            }
        }
        ... on CommunityFundProduct {
            waiveFeeReserve
            totals {
                availableToGrant
                estimatedFeeReserve
                uncalledCapital
            }
        }
        ... on ClatProduct {
            totals {
                cash
                stock
            }
        }
    }
`;

export { sharedFeeTransactionFields, workflowProductTotals };